module.exports = __webpack_public_path__ + "static/img/sz-kf.53dd59d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/case/sz-kf.jpg
// module id = rDbj
// module chunks = 1